@if (review) {
  <div class="review-detail">
    <!-- Review Content -->
    <div class="section">
      <h3>Review</h3>
      @if (titleValue) {
        <div class="field-row">
          <label>Title:</label>
          <span><b>{{titleValue}}</b></span>
        </div>
      }
      <div class="field-row">
        <label>Overall Rating:</label>
        <p-rating [(ngModel)]="overallRating" [readonly]="true" [stars]="5" [cancel]="false"></p-rating>
      </div>
      <div class="field-row">
        <label>Review Text:</label>
        <div class="review-body">{{bodyValue}}</div>
      </div>
      <div class="field-row">
        <label>Date:</label>
        <span>{{submittedDate | date:'medium'}}</span>
      </div>
      <div class="field-row">
        <label>Status:</label>
        <p-dropdown [options]="statuses" [(ngModel)]="selectedStatus"
          optionLabel="name" optionValue="value" placeholder="Select Status">
        </p-dropdown>
        <button pButton pRipple class="p-button-sm p-button-success"
          label="Update Status" (click)="onStatusChange()"
          [disabled]="statusUpdating" style="margin-left: 10px;">
        </button>
      </div>
      @if (review.reviewSource) {
        <div class="field-row">
          <label>Source:</label>
          <span>{{review.reviewSource}}</span>
        </div>
      }
      @if (review.vrboReviewId) {
        <div class="field-row">
          <label>VRBO Review ID:</label>
          <span>{{review.vrboReviewId}}</span>
        </div>
      }
      @if (review.checkInDate) {
        <div class="field-row">
          <label>Check-In Date:</label>
          <span>{{review.checkInDate | date:'mediumDate'}}</span>
        </div>
      }
      @if (review.numNights) {
        <div class="field-row">
          <label>Number of Nights:</label>
          <span>{{review.numNights}}</span>
        </div>
      }
    </div>
    <!-- Reviewer Info -->
    <div class="section">
      <h3>Reviewer</h3>
      <div class="field-row">
        <label>Name:</label>
        <span>{{reviewerName}}</span>
      </div>
      @if (review.screenName) {
        <div class="field-row">
          <label>Screen Name:</label>
          <span>{{review.screenName}}</span>
        </div>
      }
      @if (review.emailAddress) {
        <div class="field-row">
          <label>Email:</label>
          <span>{{review.emailAddress}}</span>
        </div>
      }
      @if (reviewerLocation) {
        <div class="field-row">
          <label>Location:</label>
          <span>{{reviewerLocation}}</span>
        </div>
      }
      @if (review.adults || review.children) {
        <div class="field-row">
          <label>Guests:</label>
          <span>{{review.adults || 0}} Adults, {{review.children || 0}} Children</span>
        </div>
      }
    </div>
    <!-- Property Info -->
    <div class="section">
      <h3>Property</h3>
      @if (review.propertyCode) {
        <div class="field-row">
          <label>Property Code:</label>
          <span>{{review.propertyCode}}</span>
        </div>
      }
      <div class="field-row">
        <label>Short Term Rental ID:</label>
        <span>{{shortTermRentalId}}</span>
      </div>
      @if (supplierReservationId) {
        <div class="field-row">
          <label>Reservation ID:</label>
          <span>
            {{supplierReservationId}}
            @if (orderUrl) {
              <a [href]="orderUrl" target="_blank" style="margin-left: 8px;">View Order</a>
            }
          </span>
        </div>
      }
    </div>
    <!-- Management Response -->
    @if (responseBody) {
      <div class="section">
        <h3>Management Response</h3>
        <div class="field-row">
          <label>Response:</label>
          <div class="review-body">{{responseBody}}</div>
        </div>
      </div>
    }
    <!-- Notes -->
    @if (review.notes) {
      <div class="section">
        <h3>Notes</h3>
        <div class="review-body">{{review.notes}}</div>
      </div>
    }
    <!-- Actions -->
    <div class="section actions">
      @if (!responseBody) {
        <button pButton pRipple
          class="p-button-info" label="Respond to Review" (click)="openRespondDialog()"
        style="margin-right: 10px;"></button>
      }
      <button pButton pRipple class="p-button-success" label="Rate Guest"
      (click)="openRateGuestDialog()" style="margin-right: 10px;"></button>
      <button pButton pRipple class="p-button-secondary" label="Close"
      (click)="close()"></button>
    </div>
  </div>
}
